module.exports = __webpack_public_path__ + "img/icon_utill_set.c3608b89.svg";